export default {
  id: "cbs-programs",
  title: "CBS Programs",
  section: "Administration",
  order: 94,
  keywords: "cbs programs enrollment clients membership program filter cards",
  body: `
## What it is

CBS Programs are named client groupings — program cards showing name,
description, active status, and a live count of enrolled clients. Their
job is organizational: program membership powers the **Program filters**
elsewhere in the app (for example on the Verification page), so keeping
enrollment accurate keeps those filters meaningful.

## Step by step: managing enrollment

1. Open **CBS Programs** and find the program's card.
2. Click **Manage Clients**.
3. To enroll: search in the add box — it only offers clients **not already
   in the program** — and add them.
4. To remove: find the client in the member list (searchable) and remove
   them.
5. Counts on the card update immediately; filters across the app follow.

## What this page does not do

Programs themselves — creating a new one, renaming, activating or
deactivating — are **not editable here**; the page manages membership only.
If the program list itself needs to change, that's a system-administrator
change, not an app operation.
`,
};
